import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { RefreshCw, HelpCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import './PaymentError.css';

const PaymentError = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  const status = searchParams.get('status');
  const statusDetail = searchParams.get('status_detail');
  
  const getErrorMessage = () => {
    switch (status) {
      case 'rejected':
        switch (statusDetail) {
          case 'cc_rejected_insufficient_amount':
            return 'Fondos insuficientes en tu tarjeta';
          case 'cc_rejected_bad_filled_card_number':
            return 'Número de tarjeta incorrecto';
          case 'cc_rejected_bad_filled_security_code':
            return 'Código de seguridad incorrecto';
          case 'cc_rejected_bad_filled_date':
            return 'Fecha de vencimiento incorrecta';
          case 'cc_rejected_high_risk':
            return 'Tu pago fue rechazado por seguridad';
          default:
            return 'Tu pago fue rechazado';
        }
      case 'cancelled':
        return 'Cancelaste el proceso de pago';
      case 'in_process':
        return 'Tu pago está siendo procesado. Te notificaremos cuando esté listo.';
      case 'pending':
        return 'Tu pago está pendiente de confirmación';
      default:
        return 'Hubo un problema al procesar tu pago';
    }
  };

  const getErrorIcon = () => {
    switch (status) {
      case 'cancelled':
        return '🚫';
      case 'in_process':
      case 'pending':
        return '⏳';
      default:
        return '❌';
    }
  };

  const handleRetry = () => {
    navigate('/admin/plans');
  };

  const handleSupport = () => {
    window.location.href = 'mailto:soporte@aturno.com?subject=Problema con el pago';
  };

  return (
    <div className="payment-error-container">
      <div className="payment-error-card">
        <div className="error-icon-wrapper">
          <span className="error-emoji">{getErrorIcon()}</span>
        </div>
        
        <h1>
          {status === 'cancelled' ? 'Pago cancelado' : 
           status === 'in_process' || status === 'pending' ? 'Pago en proceso' : 
           'Error en el pago'}
        </h1>
        
        <p className="error-message">{getErrorMessage()}</p>
        
        {statusDetail && (
          <div className="error-details">
            <p className="detail-label">Código de error:</p>
            <p className="detail-value">{statusDetail}</p>
          </div>
        )}
        
        <div className="suggestions">
          <h3>¿Qué puedes hacer?</h3>
          <ul>
            <li>Verifica que los datos de tu tarjeta sean correctos</li>
            <li>Asegúrate de tener fondos suficientes</li>
            <li>Intenta con otro método de pago</li>
            <li>Contacta a tu banco si el problema persiste</li>
          </ul>
        </div>
        
        <div className="button-group">
          <Button onClick={handleRetry} size="lg" className="retry-button">
            <RefreshCw className="mr-2" size={20} />
            Intentar nuevamente
          </Button>
          <Button onClick={handleSupport} variant="outline" size="lg">
            <HelpCircle className="mr-2" size={20} />
            Contactar soporte
          </Button>
        </div>
        
        <p className="security-note">
          🔒 Tus datos están seguros. No almacenamos información de tarjetas.
        </p>
      </div>
    </div>
  );
};

export default PaymentError;